const CALENDLY_POLL_INTERVAL_MS = 100;
const CALENDLY_MAX_ATTEMPTS = 100;

let loadPromise = null;

function waitForCalendly() {
  return new Promise((resolve, reject) => {
    let attempts = 0;

    const check = () => {
      if (window.Calendly) {
        resolve(window.Calendly);
        return;
      }

      attempts += 1;
      if (attempts >= CALENDLY_MAX_ATTEMPTS) {
        reject(new Error('Calendly failed to load'));
        return;
      }

      setTimeout(check, CALENDLY_POLL_INTERVAL_MS);
    };

    check();
  });
}

export function loadCalendly() {
  if (window.Calendly) {
    return Promise.resolve(window.Calendly);
  }

  if (!loadPromise) {
    loadPromise = waitForCalendly().catch((error) => {
      loadPromise = null;
      throw error;
    });
  }

  return loadPromise;
}
